import React from "react";
import { TransitionWrapper } from "./styles";
import { useThemeToggle } from "../../context/ThemeContext";

const variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
};

export default function PageTransition({ children }) {
  // Respeita o toggle "Animações da interface": off => transição instantânea
  // (sem fade/slide ao navegar), cumprindo o que o controle promete.
  const { animacoes = true } = useThemeToggle() || {};
  return (
    <TransitionWrapper
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={animacoes ? { duration: 0.25, ease: [0.16, 1, 0.3, 1] } : { duration: 0 }}
    >
      {children}
    </TransitionWrapper>
  );
}
